/* eslint-disable max-len */
export const dictionary = {
  AlertSendCode:
    'Enviamos um código de verificação no seu e-mail. Caso você não receba o e-mail em alguns minutos, verifique a sua caixa de spam ou repita o processo.',
  AlertSendCodeError:
    'Ocorreu um erro ao enviar o código, por favor tente mais tarde',
  AlertUserNotVerify:
    'É necessário confirmar este usuário antes de tentar recuperar a senha',
  PasswordUpdatedSuccess: 'Nova senha cadastrada com sucesso',
  ForgotPasswordExceptionCodeSendingSuccess:
    'Código enviado para o seu E-mail com sucesso',

  // Cognito Erros
  CodeMismatchException: 'Código de verificação inválido, tente novamente',
  ExpiredCodeException: 'Código inválido/expirado',
  LimitExceededException:
    'Limite de tentativas excedidas, tente novamente mais tarde',
  NotAuthorizedException: 'E-mail e/ou senha incorretos.',
  UsernameExistsException: 'Já existe uma conta com o email informado',
  UserNotConfirmedException: 'Usuário não confirmado',
  UserNotFoundException: 'E-mail e/ou senha incorretos',
  EmailNotFoundException: 'E-mail não encontrado',
  DefaultException:
    'Inconsistência nos dados enviados, tente novamente mais tarde',
  UserSuccessfullyVerified: 'Usuário verificado com sucesso',
  ResendSignUpSuccess: 'Código enviado com sucesso',
  ResendSignUpFail: 'Erro ao enviar código',
  InvalidParameterException:
    'Você precisa verificar o e-mail antes de trocar de senha.',

  // Input validate
  ValidateInvalidEmail: 'Email inválido',
  ValidateRequiredField: 'Campo obrigatório',
  ValidateMaxPassword: 'Máximo de 24 caracteres',
  ValidateMinPassword: 'Mínimo de 6 caracteres',
  ValidateMinName: 'Mínimo de 2 caracteres',
  ValidateOneLetter: 'Pelo menos uma letra',
  ValidateOneLowerChar: 'Pelo menos uma letra minúscula',
  ValidateOneUpperChar: 'Pelo menos uma letra maiúscula',
  ValidateOneNumber: 'Pelo menos um número',
  ValidateOneSpecialChar: 'Pelo menos um caracter especial',
  ValidatePasswordNotEquals: 'As senhas não são iguais',
  ValidateOnlyNumbers: 'Somente números',
  ValidateInvalidCPF: 'CPF inválido',
  ValidateInvalidCardNumber: 'Cartão inválido',
  ValidateInvalidDateExp: 'Data de expiração inválida'
}
